module.exports = __webpack_public_path__ + "img/home-hassle-free.ee9d9d62.png";